<template>
  <font-awesome-icon
    icon="trash-alt"
    :class="[defaultColor ? 'is-default' : '', 'fa']" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

export default {
  name: 'CoozzyDeleteIcon',
  props: {
    defaultColor: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
    .fa {
      color: $color-red;
      &.is-default{
        color: $color-text-grey;
      }
      &:hover {
        cursor: pointer;
      }
    }
</style>
